<template>
  <div id="fy_apply" class="parent_container">
    <div class="apply_header">
      <span>我要对接</span>
      <fy_view_pdf :pdf-index="pdfIndex" class="apply_view"></fy_view_pdf>
    </div>
    <div class="apply_footer">
      <div class="style1">
        <img src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/contact/wechat.png">
        <h4 class="text-center">方式一：微信联系</h4>
      </div>
      <div id="apply_list" class="style2">
        <div class="form-group">
          <input v-model="phone" type="number" class="form-control" placeholder="请输入联系电话">
          <div v-if="errTip[0]" class="fy_err_tip">
            <span class="glyphicon glyphicon-exclamation-sign"></span>
            请先输入您的手机号
          </div>
          <input v-model="name" class="form-control" placeholder="请输入联系人">
          <div v-if="errTip[1]" class="fy_err_tip">
            <span class="glyphicon glyphicon-exclamation-sign"></span>
            请先输入您的名字
          </div>
          <!--                    <input class="form-control" placeholder="请选择要对接的设备">-->
          <select class="form-control" v-model="selectedIndex">
            <option v-for="(name,index) in deviceList" v-bind:value="index"
                    v-bind:disabled="index === 0 ? 'disabled' : false"
                    v-bind:selected="index === 0 ? 'selected' : false">
              {{name}}
            </option>
          </select>
          <div v-if="errTip[2]" class="fy_err_tip">
            <span class="glyphicon glyphicon-exclamation-sign"></span>
            请选择您要对接的设备
          </div>
          <button type="button" class="btn btn-default btn-lg" @click="submit">
            提交
            <img v-if="isShowLoading" class="submit_svg"
                 src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/svg/loading.svg" />
            <img v-if="isShowRight" class="submit_svg"
                 src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/svg/right.svg" />
          </button>
        </div>
        <h4 class="text-center">方式二： 在线申请</h4>
      </div>
    </div>
  </div>
</template>

<script>
    import './../assets/css/fy_apply.css'
    import fy_view_pdf from "./fy_view_pdf"
    import axios from 'axios'
    export default {
        name: "fy_apply",
        components: {
            fy_view_pdf
        },
        props: ['pdfIndex'],
        data() {
            return {
                selectedIndex: 0,
                isShowRight: false,
                isShowLoading: false,
                errTip: [false,false,false],
                deviceList: ['请选择您要对接的设备', 'FY200云喇叭', 'FY070打印机'],
                phone: '',
                name: ''
            }
        },
        methods: {
            submit() {
                if (!this.phone) {
                    this.errTip = [true,false,false];
                    console.log('电话不能为空');
                    return;
                }
                if (!this.name) {
                    this.errTip = [false,true,false];
                    console.log('联系人不能为空');
                    return;
                }
                if (this.selectedIndex === 0) {
                    this.errTip = [false,false,true];
                    console.log('请选择您要对接的设备');
                    return;
                }
                this.isShowLoading = true;
                axios.post('https://pay.gzfyit.com/handy-sprite/weixin/send_device_apply',{
                    phone: this.phone,
                    name: this.name,
                    device: this.deviceList[this.selectedIndex]
                }).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.isShowRight = true;
                        this.isShowLoading = false;
                        setTimeout(()=> {
                            this.isShowRight = false;
                        },300)
                    },500)
                })
            },
        },
        watch: {
            phone() {
                this.errTip = [false,false,false];
            },
            name() {
                this.errTip = [false,false,false];
            },
            selectedIndex() {
                this.errTip = [false,false,false];
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_apply.vue